import { render } from "./SurveySingle.vue?vue&type=template&id=fd5602c8&scoped=true"
import script from "./SurveySingle.vue?vue&type=script&lang=js"
export * from "./SurveySingle.vue?vue&type=script&lang=js"

import "./SurveySingle.vue?vue&type=style&index=0&id=fd5602c8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd5602c8"]])

export default __exports__